import styled, { Color, Spacing, css } from '@nfinite/react-hubstairs/styled'

export const Label = styled('p')`
  ${Spacing.generateMargin({ vertical: '0' })}
  font-size: inherit;
  font-weight: inherit;
  line-height: 1;
  white-space: pre-line;
`

function getOrientation({ orientation }) {
  switch (orientation) {
    case 'vertical': {
      return css`
        flex-direction: column;
        align-items: center;
        ${Label} {
          ${Spacing.generateMargin({ top: 'xs' })}
        }
      `
    }
    case 'vertical-reverse': {
      return css`
        flex-direction: column-reverse;
        align-items: center;
        ${Label} {
          ${Spacing.generateMargin({ top: 'xs' })}
        }
      `
    }
    default:
    case 'horizontal': {
      return css`
        align-items: center;
        ${Label} {
          ${Spacing.generateMargin({ left: 'xs' })}
        }
      `
    }
    case 'horizontal-reverse': {
      return css`
        align-items: center;
        flex-direction: row-reverse;
        ${Label} {
          ${Spacing.generateMargin({ right: 'xs' })}
        }
      `
    }
  }
}

function getColors({ colors: { initial, hover } }) {
  const colorInitial = css`
    fill: ${Color.get(initial.name, initial.group)};
    color: ${Color.get(initial.name, initial.group)};
  `
  const colorHover =
    hover &&
    css`
      &:hover {
        fill: ${Color.get(hover.name, hover.group)};
        color: ${Color.get(hover.name, hover.group)};
      }
    `

  return css`
    ${colorInitial} ${colorHover}
  `
}

const _Wrapper = ({ orientation, colors, ...ownProps }) => <div {...ownProps} />
export const Wrapper = styled(_Wrapper)`
  display: flex;
  ${getOrientation}
  ${getColors}
`
